import { render, staticRenderFns } from "./downloadArea.vue?vue&type=template&id=6d3c50fa&scoped=true&"
import script from "./downloadArea.vue?vue&type=script&lang=js&"
export * from "./downloadArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3c50fa",
  null
  
)

export default component.exports